import {
  GET_SAVED_REPORTS,
  GET_SAVED_REPORTS_SUCCESS,
  GET_SAVED_REPORTS_FAILURE,
  SAVE_REPORT,
  SAVE_REPORT_SUCCESS,
  SAVE_REPORT_FAILURE,
  DELETE_SAVED_REPORT,
} from './actionType';

const initialState = {
  savedList: [],
  savedLoading: false,
  savedError: null,
  saving: false,
};

const ReportSaved = (state = initialState, action) => {
  switch (action.type) {
    case GET_SAVED_REPORTS:
      return { ...state, savedLoading: true, savedError: null };
    case GET_SAVED_REPORTS_SUCCESS: {
      const payload = Array.isArray(action.payload)
        ? action.payload[0]
        : action.payload;
      return {
        ...state,
        savedList: payload?.reportsaved_list || [],
        savedLoading: false,
      };
    }
    case GET_SAVED_REPORTS_FAILURE:
      return { ...state, savedLoading: false, savedError: action.payload };
    case SAVE_REPORT:
      return { ...state, saving: true };
    case SAVE_REPORT_SUCCESS:
    case SAVE_REPORT_FAILURE:
      return { ...state, saving: false };
    case DELETE_SAVED_REPORT:
      return { ...state };
    default:
      return state;
  }
};

export default ReportSaved;
